import { useNavigate } from 'react-router-dom';
import ROUTERS from '../../../../commons/constans/router';
import CharacterItem from './characterItem'
import CharacterDefault from './characterDefault'
import SwiperSlide from "./../../../../commons/components/Slider"
import { ReactComponent as IconNextPageB} from '../../../../assets/images/icon_nextpage_b.svg';
import { ReactComponent as IconPlus } from '../../../../assets/images/icon_plus.svg';
type Props = {
  // onClickCharacter: Function
}

const Character = ({ characters, setPopupListChildren }: Props) => {
  const navigate = useNavigate()

  const redirectToAlbum = () => {
    // navigate(ROUTERS.ALBUM + '?type=character_selfie');
    window.nativeOpenCamera();
  }


  return (
    <div className="box-character-selfie">
      <div className="box-character-selfie__header">
        <div className="flex-header">
          <div className="left">
            <h3 className="title-character">캐릭터셀카</h3>
          </div>
          <div className="icon-character" onClick={redirectToAlbum}>
            {/* <img src={IconNextPageB} alt="" /> */}
            <IconNextPageB />
          </div>
        </div>
        <p className="check-character">
          아이가 좋아하는 캐릭터와 함께사진 촬영을 해보세요!
        </p>
      </div>
      <div className="box-character-selfie__content">
        <div className="plus-character" onClick={() => navigate(ROUTERS.CHILDREN_SETTING, {
          state: {
            pathName: 'home'
          }
        })}>
          {/* <img className="img-plus" src="/images/icon_plus.svg" alt="" /> */}
          <span className="img-plus">
             <IconPlus />
          </span>
        </div>
        {characters.length ? (
          characters.length > 2 ? (
          <SwiperSlide
            spaceBetween={5}
            slidesPerView={2.4}
            classSwiper="swiper-slide-favorite-character"
          >
            {characters.map((character, key) => (
                <CharacterItem character={character} key={key}/>
            ))}
          </SwiperSlide>
          ) : (
            <>
              <CharacterItem character={characters[0]} style={{width: "32.5%"}} />
              {characters[1] ? <CharacterItem character={characters[1]} style={{width: "32.5%", marginLeft:"10px"}} /> : null }
            </>
          )
        ) : (
          <CharacterDefault />
        )}
      </div>
    </div>
  )
}

export default Character
